module.exports = __webpack_public_path__ + "img/spm.df13296.gif";